import React from 'react';

const TextArea = ({
  title, onChange, value, maxLength, placeHolder, rows,
}) => (
  <div className="form-group">
    <p className="margin-bottom-2">{title}</p>
    <textarea
      value={value}
      onChange={onChange}
      className="form-control"
      placeholder={placeHolder}
      rows={rows}
      maxLength={maxLength}
    />
  </div>
);

export default TextArea;
